import axiosInstance from 'api/axiosInstance';

type BEFinConsents = {
  intervatApi: boolean;
  mmfApi: boolean;
};

export interface BEFinSessionResponse {
  isSessionActive: boolean;
  expiresIn?: number; // in seconds
  consents?: BEFinConsents;
  isManualSyncAvailable?: boolean;
  expirationDate?: string;
  sessionVATNumber?: string;
  intervatGrantedWorkspaceId?: string;
}
export const getBEFinSession = async (): Promise<BEFinSessionResponse> =>
  axiosInstance.get('v2/users/minfin/session');

export const loginToBEFin = async (
  redirectUrl: string,
): Promise<{ authUri: string }> =>
  axiosInstance.get(
    `/v2/users/minfin/login?redirectUrl=${encodeURIComponent(redirectUrl)}`,
    { ignoreToast: true },
  );

export const syncBEFinSession = async (): Promise<{ ok: boolean }> =>
  axiosInstance.post<any, { ok: boolean }>('v2/users/minfin/synchronize');

export const deleteBEFin = async (): Promise<void> =>
  axiosInstance.delete('v2/users/minfin');

export const grantIntervatAccessToWorkspace = async (
  workspaceId: string,
): Promise<{ granted: boolean }> =>
  axiosInstance.post('v2/users/minfin/intervat-grant', { workspaceId });

export const revokeIntervatAccessToWorkspace = async (
  workspaceId: string,
): Promise<{ revoked: boolean }> =>
  axiosInstance.delete('v2/users/minfin/intervat-grant', {
    data: { workspaceId },
  });
